import React from "react";
import OrderContainer from "../containers/Order";

const Order = () => {
  return <OrderContainer />;
};

export default Order;
